import { fn } from 'storybook/test';

import type { Meta, StoryFn } from '@storybook/react';
import type { TextAreaProps } from './TextArea';

import { TextArea } from './TextArea';

const codeString = `
  <TextArea label={label} maxCharacters={maxCharacters} defaultValue={string}/> `;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/TextArea',
  component: TextArea,
  argTypes: { label: { control: 'text' }, maxCharacters: { control: 'number' } },
  parameters: { inspectComponent: TextArea, codeString: codeString },
} as Meta<TextAreaProps>;

const Template: StoryFn<TextAreaProps> = (args) => <TextArea {...args} />;

export const TextAreaExample = Template.bind({});
TextAreaExample.args = {
  label: 'Sample label',
  maxCharacters: 140,
  defaultValue: 'Sample default value',
  onChange: fn(),
};

export const TextAreaSubtitleExample = Template.bind({});
TextAreaSubtitleExample.args = {
  label: 'Sample label',
  subLabel: 'Sample sub label',
  maxCharacters: 140,
  defaultValue:
    'Sample default value \n Sample default value \n Sample default value \n Sample default value \n Sample default value',
  onChange: fn(),
};
